import { TransportManagementFilterName } from '../constants/transport-management.constant';

export class TransportManagementFiltersLoad {
  public static readonly type = '[TransportManagementFilters] Load';
}

export class TransportManagementFilterUpdate {
  public static readonly type = '[TransportManagementFilters] Update';
  constructor(public payload: TransportManagementFilterName[]) {}
}

export class TransportManagementFiltersInitialState {
  public static readonly type = '[TransportManagementFilters] Set Initial State';
}
